import styled from 'styled-components';
import { RadioInput } from '@app/src/common/RadioInput';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { withShimmer } from '@app/src/common/withShimmer';

export const RadioInputWrapper = styled(RadioInput)`
  align-items: flex-start;
  margin-bottom: 11px;
  >i {
    margin-top: 11px;
  }
`;

export const Option = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin-left: 6px;
`;

export const Title = styled.span`
  font-size: 16px;
  color: ${COLORS.BLACK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-weight: 600;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;
  }
`;

export const IconWrapper = styled.span`
  width: 23px;
  margin: 8px 0 0 6px;
`;

export const OptionShimmer = styled.div`
  display: flex;
  margin-bottom: 11px;
`;

export const CircleShimmer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  margin-top: 11px;
  overflow: hidden;
`;

export const IconShimmer = styled.div`
  width: 23px;
  height: 20px;
  margin: 10px 6px 0;
`;

export const DetailShimmer = styled.div`
  width: 100%;

  @medias (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 400px;
  }
`;

export const TitleShimmer = styled.div`
  width: 85px;
  height: 18px;
`;

export const DescriptionShimmer = styled.div`
  height: 13px;
  margin-top: 8px;
  width: 100%;
`;

export const WrapperShimmer = styled.div`
  min-height: 50px;
  width: 100%;
`;

export const Shimmer = withShimmer()(styled.div``);